import { RioComponentType } from '@backoffice-frontend/graphql'

export const READ_ONLY_VEHICLE_COMPONENTS = [
  RioComponentType.VehicleVin,
  RioComponentType.VehicleType,
  RioComponentType.FleetName,
  RioComponentType.VehicleLicensePlate,
  RioComponentType.VehicleMapVersion,
  RioComponentType.VehicleAvKitVersion,
  RioComponentType.VehicleSdsAutonomousVehicle,
  RioComponentType.VehicleSdsConnectivity,
  RioComponentType.VehicleMissionControl,
  RioComponentType.VehicleCabinSafety,
  RioComponentType.VehicleOperatorInteraction,
  RioComponentType.VehicleBattery,
]
